import {gql} from 'apollo-boost';

export const updateCartMutation = gql`
    mutation UpdateCart($cartLines: [UpdateCartInputLine!]!){
        updateCart(data: {cartLines: $cartLines}) {
            id
        }
    }
`;
